<div class="container">
  <svg
    class="spinner"
    xmlns="http://www.w3.org/2000/svg"
    width="203"
    height="203"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M3 17H1V19H3V16" stroke-width="2" class="path2" />
    <path d="M2 10V2H18V18H10V10H0" stroke-width="4" class="path" />
  </svg>
</div>
<label translate>components.spinner.Cargando</label>
